<!-- Arranca colapsada: con las cuatro categorías abiertas el card era una
     tirada de cientos de ocurrencias -->
<mat-expansion-panel class="lc-panel">
  <mat-expansion-panel-header class="lc-header">
    <mat-panel-title class="lc-title">
      @if (icono) {
        <mat-icon class="lc-icono" [style.color]="color">{{ icono }}</mat-icon>
      } @else {
        <!-- El mismo marker que se dibuja en el mapa -->
        <span
          class="lc-marker"
          [style.background]="color"
          [style.box-shadow]="
            '0 0 0 3px ' + color + '47, 0 0 0 1px rgba(0, 0, 0, 0.12)'
          "
        ></span>
      }
      <span class="lc-titulo-texto">{{ titulo }}</span>
      @if (umbral) {
        <span class="lc-umbral">{{ umbral }}</span>
      }
    </mat-panel-title>
    <mat-panel-description class="lc-desc">
      @if (cargando) {
        <mat-spinner diameter="14"></mat-spinner>
      } @else {
        {{ contador }}
      }
    </mat-panel-description>
  </mat-expansion-panel-header>

  <!-- Filtros propios de la categoría (los chips de eventos, el motor de las
       paradas): van arriba de la lista y los aporta quien la usa -->
  <ng-content></ng-content>

  @if (cargando) {
    <div class="lc-cargando">
      <mat-spinner diameter="20"></mat-spinner>
    </div>
  } @else if (items.length === 0) {
    <p class="lc-vacio">{{ textoVacio }}</p>
  } @else {
    <div class="lc-items">
      @for (item of items; track item.id) {
        <mat-expansion-panel
          class="lc-item"
          [class.lc-item-selected]="item.seleccionado"
        >
          <mat-expansion-panel-header class="lc-item-header">
            <mat-panel-title class="lc-item-title">
              <span
                class="lc-marker"
                [style.background]="color"
                [style.box-shadow]="
                  '0 0 0 3px ' + color + '47, 0 0 0 1px rgba(0, 0, 0, 0.12)'
                "
              ></span>
              <span class="lc-item-titulo-texto">{{ item.titulo }}</span>
            </mat-panel-title>
            @if (item.descripcion) {
              <mat-panel-description
                class="lc-item-desc"
                [style.color]="item.colorDescripcion || null"
              >
                {{ item.descripcion }}
              </mat-panel-description>
            }
          </mat-expansion-panel-header>

          <div class="lc-item-content">
            @if (item.detalles?.length) {
              <div class="lc-detalles">
                @for (detalle of item.detalles; track detalle.label) {
                  <div class="lc-detalle">
                    @if (detalle.icono) {
                      <mat-icon class="lc-detalle-icono">
                        {{ detalle.icono }}
                      </mat-icon>
                    }
                    <div class="lc-detalle-info">
                      <span class="lc-detalle-label">{{ detalle.label }}</span>
                      <span class="lc-detalle-valor">{{ detalle.valor }}</span>
                    </div>
                  </div>
                }
              </div>
            }

            @if (item.nota) {
              <div class="lc-nota">{{ item.nota }}</div>
            }

            <div class="lc-acciones">
              <button
                irxBoton="tonal"
                class="lc-boton"
                (click)="onVerEnMapa(item)"
              >
                <mat-icon>visibility</mat-icon>
                Ver en mapa
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      }
    </div>
  }
</mat-expansion-panel>
